define('modules/lp_integration/views/mdirector_fields_steps',['require','exports','module','base/collectionview','./webservice_fields_step_itemview','./mdirector_fields_step_itemview','./mdirector_fields_step_empty_view','ldsh!../templates/mdirector_fields_steps'],function(require, exports, module){
  "use strict";

  var CollectionView = require("base/collectionview"),
      FieldsStep = require("./webservice_fields_step_itemview"),
      MdirectorFieldsStep = require("./mdirector_fields_step_itemview"),
      EmptyFieldsStep = require("./mdirector_fields_step_empty_view");

  module.exports = CollectionView.extend({
    template: require("ldsh!../templates/mdirector_fields_steps"),
    tagName: "form",
    className: "form-horizontal row",
    itemContainer: "#fields-step",
    itemView: MdirectorFieldsStep,
    emptyViewType: EmptyFieldsStep,
    initialize: function(options) {
      this.defaultFields = options.defaultFields || [];
    },
    helpers: function() {
      return {
        defaultFields: this.defaultFields,
        hasFormFields: this.collection.length
      };
    },
    onRender: function() {
      this.$el.i18n();
    }
  });
});

